import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
export const InputText = ({
  name,
  control,
  label,
  type = 'text',
  variant = 'filled',
  className = '',
  register,
  validation = {},
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          {...register(name, validation)}
          type={type}
          helperText={null}
          size="small"
          error={!!error}
          onChange={e => {
            let value = e.target.value;
            if (type === 'number' && !/^(0|[1-9]\d*)$/.test(value)) {
              return;
            }
            onChange(value);
          }}
          value={value}
          fullWidth
          label={label}
          variant={variant}
          className={className}
        />
      )}
    />
  );
};
